// extracted by mini-css-extract-plugin
export default {"export_btn":"export_btn__2ROQ5","title":"title__9vKLc","avg":"avg__p3wx6","max":"max__1FdRF","min":"min__KUmdo","sort_able":"sort_able__2DJs6"};